export const FORCE_TRIGGER_TOOLTIP = "When checked, the 'enabled' field in the slug definition will be ignored and task will be executed anyway"; 